import './style.scss'
import { ChangeCompanyTypeModal } from './Components/ChangeCompanyTypeModal'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { thunkGetTaxAuthority } from 'features/System/systemSlice'
import ModalNotificationPopUp from '../ModalNotificationPopUp'

function SystemNotifycationModal() {
  // const { title, describeText, icon, ...restProps } = props
  const [isShow, setIsShow] = useState(true)
  const [isShowInvoiceNo, setIsShowInvoiceNo] = useState(
    localStorage.getItem('hideNotificationPopup') == null
      ? true
      : !localStorage.getItem('hideNotificationPopup'),
  )
  const { company } = useSelector((state) => state?.system)
  const dispatch = useDispatch()
  useEffect(() => {
    if (company.provinceId) {
      dispatch(
        thunkGetTaxAuthority({
          provinceId: company.provinceId,
        }),
      )
    }
  }, [company, company.provinceId, dispatch])
  // return <></> // mặc định không hiển thị modal
  return isShowInvoiceNo ? (
    <ModalNotificationPopUp
      title="Cập nhật tự động Số hóa đơn và Ký hiệu hóa đơn"
      describeText="describeText"
      show
      onClose={() => setIsShowInvoiceNo(false)}
    />
  ) : company?.isUpdated == false ? (
    <ChangeCompanyTypeModal
      show={isShow && company?.isUpdated == false}
      // show={isShow}
      setShow={setIsShow}
      company={company}
    />
  ) : null
}
export default SystemNotifycationModal
